export namespace RefundTypes {

    export const RefundType = Symbol("RefundType");
    export interface RefundType {
        [RefundType]: boolean;
    }

    export interface RefundTypeDto {
        $type: string;
        value: RefundTypeValueDto;
    }

    export interface RefundTypeValueDto {
        //
    }

    export function serializeRefundType(action: RefundType): RefundTypeDto {
        if (!action) {
            return null;
        }

        for (let refundType of refundTypes) {
            if (refundType.isInstanceOf(action)) {
                return {
                    $type: refundType.key,
                    value: refundType.serialize(action)
                };
            }
        }

        throw new Error("Invalid status type");
    }

    export function deserializeRefundType(dto: RefundTypeDto): RefundType {
        if (!dto) {
            return null;
        }

        for (let refundType of refundTypes) {
            if (refundType.key === dto.$type) {
                return refundType.deserialize(dto.value);
            }
        }

        throw new Error("Invalid status type");
    }

    export function getRefundTypeName(status: RefundType): string {

        for (let refundType of refundTypes) {
            if (refundType.isInstanceOf(status)) {
                return refundType.name;
            }
        }

        throw new Error("Invalid status type");
    }

    export function createRefundType(key: string): RefundType {

        for (let refundType of refundTypes) {
            if (refundType.key === key) {
                return refundType.create();
            }
        }

        throw new Error("Invalid refundType key");
    }



    export const CreditRefundType = Symbol("CreditRefundType");
    export interface CreditRefundType extends RefundType {
        [CreditRefundType]: boolean;
        CreditId: string | null;
    }

    export function isCreditRefundType(val: RefundType): val is CreditRefundType {
        return val && (val as CreditRefundType)[CreditRefundType] === true;
    }

    export interface CreditRefundTypeValueDto extends RefundTypeValueDto {
        creditId: string | null;
    }

    export const CreditRefundTypeDefinition: RefundTypeDefinitionT<CreditRefundType, CreditRefundTypeValueDto> =
    {
        key: "Credit",
        name: "Credit",
        isInstanceOf: (refundType: RefundType) => isCreditRefundType(refundType),
        create: (): CreditRefundType => {
            return {
                [RefundType]: true,
                [CreditRefundType]: true,
                CreditId: null
            };
        },
        serialize: (refundType: CreditRefundType): CreditRefundTypeValueDto => {
            return {
                creditId: refundType.CreditId
            };
        },
        deserialize: function (this: RefundTypeDefinition, dto: CreditRefundTypeValueDto) {
            const credit = this.create() as CreditRefundType;
            credit.CreditId = dto.creditId;
            return credit;
        }
    };

    export const SCBRefundType = Symbol("SCBRefundType");
    export interface SCBRefundType extends RefundType {
        [SCBRefundType]: boolean;
    }

    export function isSCBRefundType(val: RefundType): val is SCBRefundType {
        return val && (val as SCBRefundType)[SCBRefundType] === true;
    }

    export interface SCBRefundTypeValueDto extends RefundTypeValueDto {
        //
    }

    export const SCBRefundTypeDefinition: RefundTypeDefinition = {
        key: "SCB",
        name: "Bank Transfer - SCB",
        isInstanceOf: (refundType: RefundType) => isSCBRefundType(refundType),
        create: (): SCBRefundType => {
            return {
                [RefundType]: true,
                [SCBRefundType]: true
            };
        },
        serialize: (refundType: SCBRefundType): SCBRefundTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: RefundTypeDefinition, dto: SCBRefundTypeValueDto) {
            const scb = this.create() as SCBRefundType;
            return scb;
        }
    };


    export const CashRefundType = Symbol("CashRefundType");
    export interface CashRefundType extends RefundType {
        [CashRefundType]: boolean;
    }

    export function isCashRefundType(val: RefundType): val is CashRefundType {
        return val && (val as CashRefundType)[CashRefundType] === true;
    }

    export interface CashRefundTypeValueDto extends RefundTypeValueDto {
        //
    }

    export const CashRefundTypeDefinition: RefundTypeDefinition = {
        key: "Cash",
        name: "Cash",
        isInstanceOf: (refundType: RefundType) => isCashRefundType(refundType),
        create: (): CashRefundType => {
            return {
                [RefundType]: true,
                [CashRefundType]: true
            };
        },
        serialize: (refundType: CashRefundType): CashRefundTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: RefundTypeDefinition, dto: CashRefundTypeValueDto) {
            const scb = this.create() as CashRefundType;
            return scb;
        }
    };


    export const AdjustmentRefundType = Symbol("AdjustmentRefundType");
    export interface AdjustmentRefundType extends RefundType {
        [AdjustmentRefundType]: boolean;
    }

    export function isAdjustmentRefundType(val: RefundType): val is AdjustmentRefundType {
        return val && (val as AdjustmentRefundType)[AdjustmentRefundType] === true;
    }

    export interface AdjustmentRefundTypeValueDto extends RefundTypeValueDto {
        //
    }

    export const AdjustmentRefundTypeDefinition: RefundTypeDefinition = {
        key: "Adjustment",
        name: "Adjustment",
        isInstanceOf: (refundType: RefundType) => isAdjustmentRefundType(refundType),
        create: (): AdjustmentRefundType => {
            return {
                [RefundType]: true,
                [AdjustmentRefundType]: true
            };
        },
        serialize: (refundType: AdjustmentRefundType): AdjustmentRefundTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: RefundTypeDefinition, dto: AdjustmentRefundTypeValueDto) {
            const adjustment = this.create() as AdjustmentRefundType;
            return adjustment;
        }
    };




    export const WiseRefundType = Symbol("WiseRefundType");
    export interface WiseRefundType extends RefundType {
        [WiseRefundType]: boolean;
    }

    export function isWiseRefundType(val: RefundType): val is WiseRefundType {
        return val && (val as WiseRefundType)[WiseRefundType] === true;
    }

    export interface WiseRefundTypeValueDto extends RefundTypeValueDto {
        //
    }

    export const WiseRefundTypeDefinition: RefundTypeDefinition = {
        key: "Wise",
        name: "Wise",
        isInstanceOf: (refundType: RefundType) => isWiseRefundType(refundType),
        create: (): WiseRefundType => {
            return {
                [RefundType]: true,
                [WiseRefundType]: true
            };
        },
        serialize: (refundType: WiseRefundType): WiseRefundTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: RefundTypeDefinition, dto: WiseRefundTypeValueDto) {
            const wise = this.create() as WiseRefundType;
            return wise;
        }
    };




    export const CreditCardRefundType = Symbol("CreditCardRefundType");
    export interface CreditCardRefundType extends RefundType {
        [CreditCardRefundType]: boolean;
    }

    export function isCreditCardRefundType(val: RefundType): val is CreditCardRefundType {
        return val && (val as CreditCardRefundType)[CreditCardRefundType] === true;
    }

    export interface CreditCardRefundTypeValueDto extends RefundTypeValueDto {
        //
    }

    export const CreditCardRefundTypeDefinition: RefundTypeDefinition = {
        key: "CreditCard",
        name: "CreditCard",
        isInstanceOf: (refundType: RefundType) => isCreditCardRefundType(refundType),
        create: (): CreditCardRefundType => {
            return {
                [RefundType]: true,
                [CreditCardRefundType]: true
            };
        },
        serialize: (refundType: CreditCardRefundType): CreditCardRefundTypeValueDto => {
            return {
                //
            };
        },
        deserialize: function (this: RefundTypeDefinition, dto: CreditCardRefundTypeValueDto) {
            const creditCard = this.create() as CreditCardRefundType;
            return creditCard;
        }
    };





    interface RefundTypeDefinition {
        key: string;
        name: string;
        isInstanceOf: (refundType: RefundType) => boolean;
        create: () => RefundType;
        serialize: (refundType: RefundType) => RefundTypeValueDto;
        deserialize: (dto: RefundTypeValueDto) => RefundType;
    }

    interface RefundTypeDefinitionT<T, TDto> extends Omit<RefundTypeDefinition, 'create' | 'serialize' | 'deserialize'> {
        create: () => T;
        serialize: (refundType: T) => TDto;
        deserialize: (dto: TDto) => T;
    }

    const refundTypes: RefundTypeDefinition[] = [
        CreditRefundTypeDefinition,
        AdjustmentRefundTypeDefinition,
        WiseRefundTypeDefinition,
        CreditCardRefundTypeDefinition,
        SCBRefundTypeDefinition,
        CashRefundTypeDefinition
    ]

}
